<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalSubText from "@/components/global-themed/ui/modals/ModalSubText.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";

const emit = defineEmits(['close']);
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[468px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader class="tw-items-center">
          <KitIcon
            class="tw-w-[104px]"
            state="wink"
          />

          <ModalHeader>
            <ModalHeading>Great!</ModalHeading>

            <ModalSubText>
              Thanks - I’m on it! I’ll take care of this for you now.
            </ModalSubText>
          </ModalHeader>
        </KitModalHeader>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
